import { render, staticRenderFns } from "./ServicePackageProgramList.vue?vue&type=template&id=056a2a83&scoped=true"
import script from "./ServicePackageProgramList.vue?vue&type=script&lang=js"
export * from "./ServicePackageProgramList.vue?vue&type=script&lang=js"
import style0 from "./ServicePackageProgramList.vue?vue&type=style&index=0&id=056a2a83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056a2a83",
  null
  
)

export default component.exports